module.exports = __webpack_public_path__ + "img/vLogo.43d80c34.png";